<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-datepicker [(ngModel)]="value" size="small" [placeholder]="placeholderFormat" class="w-full" appendTo="body"
      showIcon [ngClass]="recovery ? 'recover-data' : ''" iconDisplay="input" [dateFormat]="dateFormat"
      [disabled]="disabled" autocomplete="off" [showOnFocus]="false" (ngModelChange)="changeDate($event)" />
  </div>
</ng-container>